<template>
  <v-card class="with-shadow rounded">
    <v-card-title class="headline">
      Surat Masuk Hari Ini
    </v-card-title>
    <v-card-text>
      <v-data-table hide-default-footer :headers="headers" :items="items" />
    </v-card-text>
  </v-card>
</template>

<script>
import { todayInboxSummary } from '@/services/dashboard'

export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Pengolah',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Total',
          value: 'total',
          align: 'center',
          sortable: false
        }
      ],
      items: []
    }
  },
  mounted() {
    this.fetchSummary()
  },
  methods: {
    async fetchSummary() {
      try {
        this.loading = true
        const { data } = await todayInboxSummary()
        this.items = data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style></style>
